/**
 * Groups-only trading gate — FE mirror of the backend activation 400.
 *
 * Only group engines may trade: activating a rule on a pair with no opener
 * group is refused by the backend ("Pair is not assigned to an opener group
 * …"). The activation switches mirror that contract visually — an UNGROUPED
 * pair's OFF switch is disabled with a tooltip instead of letting the
 * operator click into a guaranteed rejection.
 *
 * Turning OFF is never blocked: an already-armed flag on an ungrouped pair
 * (legacy state predating groups-only trading) must stay operable so the
 * operator can always disarm it.
 */
export const UNGROUPED_ACTIVATION_TOOLTIP =
  'Assign the pair to a group to trade';

export function isActivationBlocked(
  pair: { openerGroupId?: string | null },
  currentlyOn: boolean
): boolean {
  return pair.openerGroupId == null && !currentlyOn;
}
